import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import "pepsico-ds/css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'pepsico-ds'
import "pepsico-ds/css"
import gtPressuraLCGFont from './assets/fonts/GT-Pressura-LCG-Standard-Black.otf';
import gilroySemiBoldFont from './assets/fonts/Gilroy-SemiBold.otf';

// Preload custom fonts as early as possible so the browser starts
// downloading them in parallel with the app bundle, minimizing the
// visible flash of fallback-font text before they're applied.
[gtPressuraLCGFont, gilroySemiBoldFont].forEach((fontUrl) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'font';
  link.href = fontUrl;
  link.type = 'font/otf';
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
